Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.EmailContentFactory

  create: (socialContent, allTags) ->
    content = new Monitoring.Models.SocialContents.EmailContent(socialContent)
    content.set({ possibleTags: allTags })
    content.standarizeEmail()
    return content

  canHandle: (socialContent) ->
    return socialContent.group_type == 'inbox' and socialContent.data and socialContent.data.type == 'email' and socialContent.data.sub_type == 'email'
